var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"material-icons icon",class:_vm.iconState,on:{"click":_vm.change}},[_vm._v(_vm._s(_vm.iconName))])
}
var staticRenderFns = []

export { render, staticRenderFns }